import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import _ from 'lodash';
import thumb_biller from 'assets/img/thumb-biller.png';
import Img from './Img';

class BillersList extends Component {
  static propTypes = {
    emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    match: PropTypes.instanceOf(Object).isRequired,
    data: PropTypes.instanceOf(Array).isRequired,
  }

  static defaultProps = {
    emptyMessage: 'There are no billers.',
  }

  render() {
    const { data, match, emptyMessage } = this.props;
    return data.length < 1 ? (
      <div className="text-center w-100 mt-3 mb-5">
        { emptyMessage }
      </div>
    ) : data.map((biller, index) => {
      const isAvailable = !_.isEmpty(Array.isArray(biller.meta) ? biller.meta : _.get(biller, 'meta.parameters') || []);
      const rowKey = `${biller.code}-${index}`;
      return (
        <div className={`box-biller-wrapper ${!isAvailable ? 'greyscale' : ''}`} key={rowKey}>
          <Link
            // onClick={(e) => { if (!isAvailable) e.preventDefault(); }}
            className="d-block box-biller"
            to={`${match.url}/${biller.code}`}
          >
            <div className="img-holder img-xs d-flex align-items-center mx-auto">
              <Img
                src={biller.logo}
                defaultSrc={thumb_biller}
                alt={biller.name}
                className="img-fluid"
              />
            </div>
            <div className="d-flex title-biller">
              <div className={!isAvailable ? 'inner mx-auto text-center text-truncate-2' : 'inner mx-auto text-center text-truncate-2'}>
                { biller.name }
              </div>
            </div>
          </Link>
        </div>
      );
    });
  }
}

export default withRouter(BillersList);
